/**
 *
 *
 *
 *
 */

export function isSmallDot(dotIndex: number, activeDot: number, amountDots: number): boolean {
  if (amountDots <= 5) return false;

  /*                                                                                             */
  if (activeDot <= 2) {
    return dotIndex >= 4;
  }

  /*                                                                                    */
  if (activeDot >= amountDots - 3) {
    return dotIndex <= amountDots - 5;
  }

  /*                                                         */
  /*                                                                                 */
  return dotIndex <= activeDot - 2 || dotIndex >= activeDot + 2;
}
